
import { htmlTheme } from './html.js'
// import  { bootstrap2Theme } from  './bootstrap2'
import { bootstrap3Theme } from './bootstrap3.js'
import { bootstrap4Theme } from './bootstrap4.js'
import { bootstrap5Theme } from './bootstrap5.js'
// import  { foundationTheme, foundation3Theme, foundation4Theme, foundation5Theme, foundation6Theme } from  './foundation.js'
import { jqueryuiTheme } from './jqueryui.js'
import { barebonesTheme } from './barebones.js'
// import  { materializeTheme } from  './materialize'
import { spectreTheme } from './spectre.js'
import { tailwindTheme } from './tailwind.js'

export const themes = {
  html: htmlTheme,
  // bootstrap2: bootstrap2Theme,
  bootstrap3: bootstrap3Theme,
  bootstrap4: bootstrap4Theme,
  bootstrap5: bootstrap5Theme,
  // foundation: foundationTheme,
  // foundation3: foundation3Theme,
  // foundation4: foundation4Theme,
  // foundation5: foundation5Theme,
  // foundation6: foundation6Theme,
  jqueryui: jqueryuiTheme,
  barebones: barebonesTheme,
  // materialize: materializeTheme,
  spectre: spectreTheme,
  tailwind: tailwindTheme
}
